import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import logoutAndRedirect from "../../utils/logoutAndRedirect";
import { getAccessToken } from "../../utils/tokenStore";

const URL_API = process.env.URL_API;

export interface ScheduleResult {
    data: any[];
}

export const fetchSchedules = createAsyncThunk(
    'calendar/fetch',
    async (params: any, { rejectWithValue }) => {
        const api_url = `${URL_API}/supplier-portal/calendar`;

        try {
            const { data } = await axios.get<ScheduleResult>(api_url, {
                headers: {
                    'Authorization': `Bearer ${getAccessToken()}`
                },
                params: params
            });
            return data;
        } catch (error) {
            // @ts-ignore
            if (error.response?.status === 401) {
                logoutAndRedirect('/sign-in')
            }
            // @ts-ignore
            return rejectWithValue(error.response?.data ?? error)
        }
    }
);


export const fetchJobSchedules = createAsyncThunk(
    'calendar/jobSchedules',
    async (params: any, { rejectWithValue }) => {
        const supplierUrl = `${URL_API}/supplier-portal/jobs/${params.id}/calendar`;
        try {
            const { data } = await axios.get<ScheduleResult>(supplierUrl, {
                headers: {
                    'Authorization': `Bearer ${getAccessToken()}`
                }
            });
            return data;
        } catch (error) {
            // @ts-ignore
            if (error.response?.status === 401) {
                logoutAndRedirect('/sign-in')
            }
            // @ts-ignore
            return rejectWithValue(error.response?.data ?? error)
        }
    }
);

export const fetchPropertySchedules = createAsyncThunk(
    'calendar/propertySchedules',
    async (params: any, { rejectWithValue }) => {
        const supplierUrl = `${URL_API}/supplier-portal/properties/${params.consumerId}/calendar`;
        const filters = {
            exclude_completed: params.exclude_completed || true,
            ...params,
        };
        try {
            const { data } = await axios.get<ScheduleResult>(supplierUrl, {
                headers: {
                    'Authorization': `Bearer ${getAccessToken()}`
                },
                params: filters
            });
            return data;
        } catch (error) {
            // @ts-ignore
            if (error.response?.status === 401) {
                logoutAndRedirect('/sign-in')
            }
            // @ts-ignore
            return rejectWithValue(error.response?.data ?? error)
        }
    }
);
